import { Filter } from "./filter";

export class ByStatus extends Filter {
  constructor(public id?: number) {
    super("by.status");
  }
}
